import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-eye-large.tsx
/**
* icon.24.eye.large
*
* Keywords: visibility, view, show, reveal, display, watch, observe, preview
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjU1NCA1LjUxNEMxOC4xODQgNS44IDIxIDEwLjQyNiAyMSAxMmwtLjAwOS4xNjFDMjAuODExIDEzLjkyNCAxNy44MTMgMTguNSAxMiAxOC41bC0uNTU0LS4wMTRjLTUuNDUtLjI3OC04LjI2Mi00LjYxOS04LjQzNy02LjMyNUwzIDEyYzAtMS42MjUgMy02LjUgOS02LjV6TTEyIDYuNWMtMi43MDggMC00LjcyIDEuMDk0LTYuMDYyIDIuMzY2YTggOCAwIDAgMC0xLjQ5OSAxLjkxMkM0LjA5OCAxMS40MDMgNCAxMS44MzggNCAxMnMuMDk4LjU5Ny40NCAxLjIyMmE4IDggMCAwIDAgMS40OTcgMS45MTJDNy4yOCAxNi40MDYgOS4yOTMgMTcuNSAxMiAxNy41czQuNzItMS4wOTQgNi4wNjMtMi4zNjZhOCA4IDAgMCAwIDEuNDk4LTEuOTEyYy4zNDEtLjYyNS40MzktMS4wNi40MzktMS4yMjJzLS4wOTgtLjU5Ny0uNDQtMS4yMjJhOCA4IDAgMCAwLTEuNDk3LTEuOTEyQzE2LjcyIDcuNTk0IDE0LjcwOCA2LjUgMTIgNi41TTEyIDlhMyAzIDAgMSAxIDAgNiAzIDMgMCAwIDEgMC02bTAgMWEyIDIgMCAxIDAgMCA0IDIgMiAwIDAgMCAwLTQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=3613-7735
*/
const Icon24EyeLarge = memo(function Icon24EyeLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.554 5.514C18.184 5.8 21 10.426 21 12l-.009.161C20.811 13.924 17.813 18.5 12 18.5l-.554-.014c-5.45-.278-8.262-4.619-8.437-6.325L3 12c0-1.625 3-6.5 9-6.5zM12 6.5c-2.708 0-4.72 1.094-6.062 2.366a8 8 0 0 0-1.499 1.912C4.098 11.403 4 11.838 4 12s.098.597.44 1.222a8 8 0 0 0 1.497 1.912C7.28 16.406 9.293 17.5 12 17.5s4.72-1.094 6.063-2.366a8 8 0 0 0 1.498-1.912c.341-.625.439-1.06.439-1.222s-.098-.597-.44-1.222a8 8 0 0 0-1.497-1.912C16.72 7.594 14.708 6.5 12 6.5M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
		})
	});
});
//#endregion
export { Icon24EyeLarge };

//# sourceMappingURL=icon-24-eye-large.js.map